import { FabrixExternalLink } from "@nt-portal/server-sdk";
import { useDataController } from "fabrix/hooks";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { ClientExternalLinkService, FabrixExternalLinkOptions, getImageSource } from "../../services/modules/core";

const Links = () => {

  const [_data, _total, _busy, actions] = useDataController<FabrixExternalLink>(new ClientExternalLinkService());
  const [_options, setOptions] = useState<FabrixExternalLinkOptions>({
    params: {
      first: 0,
      page: 0,
      rows: 50,
      sortField: "name",
      sortOrder: 1
    },
    filter: ""
  })

  useEffect(() => {
    actions.getLookup(_options);
  }, [])


  const renderLink = (link: FabrixExternalLink) => {
    const imageSource = getImageSource(link);
    return (

      <NavLink key={link.id} to={link.url} target="_blank" className="fabrix-app-sidebar-link fabrix-app-sidebar-link--links">
        <span className="fabrix-app-sidebar-link-icon" aria-hidden="true">
          <img src={imageSource} alt="" className="fabrix-app-sidebar-link-image" />
        </span>
        <span>{link.name}</span>
      </NavLink>
    )

  }

  return (
    <div className="flex flex-wrap">
      {_data.map((link) => (
        renderLink(link)
      ))}
    </div>
  )


};




export default Links;
